export function extractAccessTokenFromLoginPayload(payload) {
  if (!payload || typeof payload !== "object") return null;

  const candidates = [
    payload.access_token,
    payload.token,
    payload.session?.access_token,
    payload.data?.access_token,
    payload.data?.token,
    payload.data?.session?.access_token,
    payload.data?.data?.access_token,
  ];

  for (const c of candidates) {
    if (typeof c === "string") {
      const t = c.trim();

      if (t.length > 0 && t !== "undefined" && t !== "null") return t;
    }
  }

  return null;
}
